// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/stylesheets/partials/procurement-model-page.scss
// module id = 452
// module chunks = 0